import RequestAbstract from "../abstract";

export default class ReportTypes extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/report-types";
    }

}
